const c = (n) => typeof n == "string" ? n.replace(" ", "-") : n.join("-"), r = (n, s) => `--${n}--${c(s)}`, e = (n, s, o) => `var(${r(n, s)}${o ? ", " + o : ""})`, i = (n, s) => {
  const o = typeof n == "string" ? n : n.displayName, t = e.bind(null, o, s);
  return t.toString = r.bind(null, o, s), t;
}, l = (n, s) => i(n, s);
export {
  i as cssToken,
  r as cssVar,
  e as getCssVar,
  l as globalCssToken
};
